module.exports = __webpack_public_path__ + "static/media/bakri-postpartum-balloon-logo@3x.4cabf274.jpg";